import { useSeo } from "../hooks/useSeo";

export default function Terms() {
  useSeo({ title: "Terms of Use — Practical AI for Everyday Life", description: "The terms for using this site." });
  return (
    <section className="sheet">
      <div className="container-brand py-16">
        <p className="eyebrow">Legal</p>
        <h1 className="mt-3 text-4xl sm:text-5xl">Terms of Use</h1>
        <div className="measure mt-8 space-y-5 text-text-body">
          <p className="text-sm text-text-muted">Last updated: {new Date().toLocaleDateString()}</p>
          <p>
            By using practicalaiforeverydaylife.com, you agree to these simple terms. If you don't agree,
            please don't use the site.
          </p>
          <h3 className="text-2xl">The content is educational</h3>
          <p>
            Everything here — guides, prompts, and setups — is shared for general educational purposes. AI
            tools change fast and can make mistakes, so always use your own judgment and double-check
            important results.
          </p>
          <h3 className="text-2xl">No guarantees</h3>
          <p>
            We share what works for us, but we can't promise specific results. You're responsible for how you
            use these tools and any third-party AI services they rely on.
          </p>
          <h3 className="text-2xl">Your content</h3>
          <p>
            When you paste a prompt into a third-party AI tool, that tool's own terms and privacy policy
            apply. We're not responsible for third-party services.
          </p>
          <h3 className="text-2xl">Intellectual property</h3>
          <p>
            The brand, artwork, and written guides on this site are original and owned by Practical AI for
            Everyday Life. You're welcome to use the prompts in your own life — just don't repackage the
            content as your own.
          </p>
          <h3 className="text-2xl">Contact</h3>
          <p>
            Questions? Email <a className="prose-link" href="mailto:hello@practicalaiforeverydaylife.com">hello@practicalaiforeverydaylife.com</a>.
          </p>
        </div>
      </div>
    </section>
  );
}
